module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 272
// module chunks = 0